import { Button } from '@mui/material'
import { Grid } from '@mui/material'

//components
import Layout from '../components/Layout'

export default function Analyser() {
  const handleClick = async () => {
    const DEVICE_NAME = 'SensorDiscProcessor'
    const SERVICE_UUID = '12345678-1234-5678-1234-56789abcdef0'
    const UNIFIED_CHAR_UUID = '87654321-4321-8765-4321-0fedcba900'
    const OPCODES = {
      MOTOR_SET_DATA: 1,

      MOTOR_GET_SET_POSITION: 2,

      MOTOR_STOP: 3,

      MOTOR_HOME: 4,
    }

    const MOTOR_BROADCAST_INDEX = 255

    const MOTOR_COUNT = 9

    // Firmware constrains speedHundredths to [1, 100] => 0.01..1.00 mm/s.

    const SPEED_MIN_MM_S = 0.01

    const SPEED_MAX_MM_S = 1.0

    const SPEED_DEFAULT_MM_S = 0.5 // firmware default when not provided

    function getSupportedProperties(characteristic) {
      let supportedProperties = []
      for (const p in characteristic.properties) {
        if (characteristic.properties[p] === true) {
          supportedProperties.push(p.toUpperCase())
        }
      }
      return '[' + supportedProperties.join(', ') + ']'
    }

    async function writeCommand(unifiedChar, bytes) {
      // bytes: Uint8Array
      await unifiedChar.writeValue(bytes)
    }

    function clampSpeedMmPerSec(speed) {
      if (speed < SPEED_MIN_MM_S) return SPEED_MIN_MM_S

      if (speed > SPEED_MAX_MM_S) return SPEED_MAX_MM_S

      return speed
    }

    async function setMotorData(
      unifiedChar,
      motorIdx,
      positionMm,
      speedMmPerSec
    ) {
      if (
        motorIdx !== MOTOR_BROADCAST_INDEX &&
        (motorIdx < 0 || motorIdx >= MOTOR_COUNT)
      ) {
        throw new RangeError('Invalid motor index')
      }

      const tens = Math.trunc(positionMm * 10) // int32

      const clampedSpeed = clampSpeedMmPerSec(speedMmPerSec)

      const speedHundredths = Math.round(clampedSpeed * 100) // 1..100

      const buf = new ArrayBuffer(7)

      const dv = new DataView(buf)

      dv.setUint8(0, OPCODES.MOTOR_SET_DATA)

      dv.setUint8(1, motorIdx & 0xff)

      dv.setInt32(2, tens, true) // LE int32

      dv.setUint8(6, speedHundredths) // 1..100

      await writeCommand(unifiedChar, new Uint8Array(buf))
    }

    try {
      console.log('Requesting any Bluetooth Device...')

      const device = await navigator.bluetooth.requestDevice({
        filters: [{ name: DEVICE_NAME }],
        optionalServices: [SERVICE_UUID],
      })

      console.log('Connecting to GATT Server...')
      const server = await device.gatt.connect()

      console.log('Getting Services...')
      const services = await server.getPrimaryServices()

      let unifiedChar = null

      console.log('Getting Characteristic...')
      for (const service of services) {
        console.log('> Service: ' + service.uuid)
        const characteristics = await service.getCharacteristics()

        characteristics.forEach((characteristic) => {
          console.log(
            '>> Characteristic: ' +
              characteristic.uuid +
              ' ' +
              getSupportedProperties(characteristic)
          )
          unifiedChar = characteristic
        })
      }

      setMotorData(unifiedChar, 0, 5, SPEED_DEFAULT_MM_S)
    } catch (error) {
      console.log('Argh! ' + error)
    }
  }

  return (
    <Layout>
      <Grid container style={{ margin: '20px auto auto auto' }}>
        <Grid
          size={{
            xs: 1,
            sm: 3,
            md: 4,
          }}
        />
        <Grid
          size={{
            xs: 10,
            sm: 6,
            md: 4,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            size="medium"
            fullWidth
            style={{ margin: '20px auto auto auto' }}
            onClick={handleClick}
          >
            Start
          </Button>
        </Grid>
        <Grid
          size={{
            xs: 1,
            sm: 3,
            md: 4,
          }}
        />
      </Grid>
    </Layout>
  )
}
